import './Logout.scss';
import { Heading } from '@lmig/lmds-react-typography';
import { FloatingHeader } from '@lmig/lmds-react-floating-header';
import { getPLDomain, getBLDomain, getPingLogoutLink, getWasLogoutLink, getSuretyUrl, getStateAutoUrl, getMiddleMarketUrl, isOneBrand, getPLOneBrandDomain, getBLOneBrandDomain, isBL, isPublic, getPingPLLogoutIFrameURL } from 'Foundation/Configurations/GlobalConfiguration';
import { Link } from '@lmig/lmds-react-link';
import { Button } from '@lmig/lmds-react-button';
import LogoutIcon from 'Images/LogoutIcon';
import { HeaderAppName } from '@lmig/lmds-react-floating-header';
import UnauthenticatedPageFooter from 'Feature/Chrome/Footer/UnauthenticatedPageFooter';

export default function Logout() {
  const isBLLogout = isBL(); //change this to isBL
  const pingLogoutUrl = getPingLogoutLink();
  const wasLogoutUrl = getWasLogoutLink();
  const suretyUrl = getSuretyUrl();
  const stateAutoUrl = getStateAutoUrl();
  const middleMarketUrl = getMiddleMarketUrl();
  const personalLinesUrl = isOneBrand() || isPublic() ? getPLOneBrandDomain() : getPLDomain();
  const commercialLinesUrl = isOneBrand() ? getBLOneBrandDomain() : getBLDomain();
  const startPageUrl = isBLLogout ? commercialLinesUrl : personalLinesUrl;
  const returnToText = isBLLogout ? 'Return to small commercial agent portal' : 'Return to personal lines agent portal';
  const appName = isBLLogout ? 'Small commercial' : 'Personal lines';

  return (
    <div className="logout-page">
      <FloatingHeader brand="liberty" isFullWidth={false} isFullBackground={false} >
        <HeaderAppName hideDivider={true}>
          {appName}
        </HeaderAppName>
      </FloatingHeader>
      <div className="logout-body">
        <div className="logout-top">
          <div className="logout-icon">
            <LogoutIcon />
          </div>
          <Heading type="h2-light">You have been logged out.</Heading>
        </div>
        <div className="logout-actions">
          <div className="logout-action-section">
            <Heading type="h4">{returnToText}</Heading>
            <Button href={startPageUrl} variant='secondary' size='medium'>Log in again</Button>
          </div>
          <div className="logout-action-section">
            <Heading type="h4">Access other agent portals</Heading>
            <ul>
              {isBLLogout ?
                <li>
                  <Link variant="standalone" href={personalLinesUrl} target="_blank">
                    Personal lines
                  </Link>
                </li>
                :
                <li>
                  <Link variant="standalone" href={commercialLinesUrl} target="_blank">
                    Small commercial
                  </Link>
                </li>
              }

              <li>
                <Link variant="standalone" href={middleMarketUrl} target="_blank">
                  Middle Market / major accounts
                </Link>
              </li>
              <li>
                <Link variant="standalone" href={suretyUrl} target="_blank">
                  Surety
                </Link>
              </li>
              <li>
                <Link variant="standalone" href={stateAutoUrl} target="_blank">
                  State Auto
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {!isBLLogout && !document?.referrer?.includes('commercial-agent.libertymutual.com') && (
          <iframe
            id="logout-placeholder-frame"
            src={getPingPLLogoutIFrameURL()}
            title="logout-placeholder"
            className="logout-placeholder-frame"
            hidden
            aria-hidden="true"
          />
        )}
      <UnauthenticatedPageFooter />

      {isBLLogout &&
        <>
          {pingLogoutUrl && <iframe hidden src={pingLogoutUrl}></iframe>}
          {wasLogoutUrl && <iframe hidden src={wasLogoutUrl}></iframe>}
        </>
      }
    </div>
  );
}
